(function( $ ) {

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 */
function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Snazzy Maps style (updated)
    var snazzyStyle = [
        {
            "featureType": "landscape.natural",
            "elementType": "geometry.fill",
            "stylers": [
                { "visibility": "on" },
                { "color": "#e0efef" }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [
                { "visibility": "on" },
                { "hue": "#1900ff" },
                { "color": "#c0e8e8" }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                { "lightness": 100 },
                { "visibility": "simplified" }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
                { "visibility": "off" }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                { "visibility": "on" },
                { "lightness": 700 }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                { "color": "#7dcdcd" }
            ]
        }
    ];

    // Create generic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP,
        styles      : snazzyStyle
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    return map;
}

/**
 * initMarker
 */
function initMarker( $marker, map ) {
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = { lat: parseFloat(lat), lng: parseFloat(lng) };

    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    map.markers.push( marker );

    if( $marker.html() ){
        var infowindow = new google.maps.InfoWindow({ content: $marker.html() });
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 */
function centerMap( map ) {
    var bounds = new google.maps.LatLngBounds();

    map.markers.forEach(function(marker){
        bounds.extend({ lat: marker.position.lat(), lng: marker.position.lng() });
    });

    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );
    } else {
        map.fitBounds( bounds );
    }
}

$(document).ready(function(){
    $('.acf-map').each(function(){
        var map = initMap( $(this) );
    });
});

})(jQuery);